<template>
    <Card
        v-if="hasStorageItem()"
        :size="`col-md-10 col-lg-8 col-xl-6 max-xl-670`"
        :newLayout="true"
        :hide-footer="true"
    >
        <template slot="card-header">
            <h1 v-translate>Something's gone wrong!</h1>
        </template>
        <template slot="card-body">
            <div class="py-4 px-4">
                <div class="d-flex justify-content-center mb-3">
                    <svg-rndr
                        :width="120"
                        svg="warning.svg"
                    />
                </div>
                <p class="text-standard mb-3 mt-4 px-3 text-center" v-translate="{ link: link }" render-html="true">
                    Please clear the cache from your browser, you can find instructions for this %{ link }. Then try to login again.
                </p>
                <p class="text-standard mb-4 text-center" v-translate>If the problem persists please contact us.</p>
                <div class="d-flex justify-content-center">
                    <router-link
                        :to="{name: 'login'}"
                        class="btn btn-primary"
                        v-translate
                    >Return to Login</router-link>
                </div>
            </div>
        </template>
    </Card>
</template>

<script>
import Card from './Card';

export default {
    name: 'SomethingsGoneWrong',
    components: {
        Card
    },
    methods: {
        hasStorageItem() {
            return localStorage.getItem('reload-count');
        }
    },
    computed: {
        link() {
            return `<a class="link" target="_blank" rel="noopener noreferrer" href="https://kinsta.com/knowledgebase/how-to-clear-browser-cache">${this.$gettext('here')}</a>`;
        }
    },
    mounted() {
        if (!localStorage.getItem('reload-count')) {
            this.$router.replace({ name: 'login' });
        }

        localStorage.removeItem('reload-count');
    }
}
</script>

<style lang="scss" scoped>
p {
    font-size: 1.15rem;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/SomethingsGoneWrong.vue